import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { FaBuildingUser, FaCheck } from "react-icons/fa6";
import { MdCancel, MdOutlineChevronRight } from "react-icons/md";
import { IoCopySharp } from "react-icons/io5";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../helpers";
import { IoMdEye, IoMdMore } from "react-icons/io";
import { FaUserClock } from "react-icons/fa";

const ReserveTenantTable = ({
    apiData,
    isMovingOut,
    setIsCancelReservation,
    setSelectedData,
    setIsMoveIn,
    setIsMoveInReschedule,
    setViewDetail
}) => {

    const storageKey = `tenant_active_page`;
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const today = moment().startOf('day');
    // Load saved page index
    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);
    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);
    const cancel = (item) => {
        setIsCancelReservation(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const movedIn = (item) => {
        setIsMoveIn(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const movedInReschedule = (item) => {
        setIsMoveInReschedule(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const view = (item) => {
        setViewDetail(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const ActionBtns = (item) => {

        const openMenu = (id) => {
            setPreviousId(openActionMenu);
            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.tenantId && (
                    <MenuOptions id="menuOptions">
                        <MenuItem
                            title="View Details"
                            onClick={() => {
                                view(item)
                            }}
                        >
                            <IoMdEye className="text-gray-700 " /> View Details
                        </MenuItem>

                        <MenuItem
                            title="Reschedule"
                            onClick={() => {
                                movedInReschedule(item)
                            }}
                        >
                            <FaUserClock className="text-gray-700 " /> Reschedule
                        </MenuItem>

                        {moment(item.moveInDate).startOf('day').isSameOrBefore(today) && (
                            <MenuItem
                                title="Move In"
                                onClick={() => {
                                    movedIn(item)
                                }}
                            >
                                <FaBuildingUser className="text-gray-700 " /> Move In
                            </MenuItem>)}
                        <MenuItem
                            title="Cancel Reservation"
                            onClick={() => {
                                cancel(item)
                            }}
                        >
                            <MdCancel className="text-gray-700 " /> Cancel Reservation
                        </MenuItem>
                    </MenuOptions>
                )
                }
                <Btn title="Actions" type="button" onClick={() => openMenu(item.tenantId)}>
                    <IoMdMore className="text-gray-600" size={24} />
                </Btn>
            </ActionBtnWrapper >
        );
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                rent: '₹' + item.rent,
                reschedule: getReschedule(item),
                roomNum: getPropertyName(item),
                moveInOutDate: isMovingOut === 'M' ? <MoveOutData>{item.moveOutDate}</MoveOutData> : moveInOutDate(item),
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getName = (item) => {
        const name = capitalizeFirstLetter(item?.name);
        return (
            <UserImageWrapper onClick={() => goToDues('Tenant Info', item)}>
                <div className="flex-row flex">
                    <UserImage src={item.profilePicture ? item.profilePicture : Images.Avatar} alt={`Avatar for ${item.name}`} />
                    {(item.kycStatus === 5 || item.kycStatus === 4) &&
                        <div className="mt-auto rounded-full bg-green-500 h-4 w-4 flex items-center justify-center -ml-2.5">
                            <FaCheck className="text-white" size={10} />
                        </div>
                    }
                </div>
                <div className="flex flex-col gap-1 max-w-36">
                    <span className="text-gray-600 text-sm font-medium line-clamp-2 block break-words overflow-hidden">
                        {/* {truncateText(name, 15)}{""} */}
                        {name}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item.mobile}</span>
                        <button onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(item.mobile);
                        }}>
                            <IoCopySharp size={10} className="text-gray-400" />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };

    const goToDues = (clickOn, item) => {
        navigate(`/tenantdetails/l/${item.tenantId}`, {
            state: {
                tabName: clickOn,
                tabKey: "totalDues",
            },
        });
    };
    const getReschedule = (item) => {
        const canMoveIn = moment(item.moveInDate).startOf('day').isSameOrBefore(today);
        if (canMoveIn) {
            return (
                <button
                    onClick={() => {
                        movedIn(item);
                    }}
                    className="text-green-600 text-sm bg-green-100 hover:bg-green-200 px-2 py-1.5 rounded-md inline-flex items-center cursor-pointer transition-all duration-200 hover:text-green-800"
                >
                    Move In
                    <MdOutlineChevronRight className="w-4 h-4 ml-1" />
                </button>
            );
        } else {
            return (
                <button
                    onClick={() => {
                        movedInReschedule(item);
                    }}
                    className="text-amber-600 text-sm bg-amber-100 hover:bg-amber-200 px-2 py-1.5 rounded-md inline-flex items-center cursor-pointer transition-all duration-200 hover:text-amber-800"
                >
                    Reschedule Booking
                    <MdOutlineChevronRight className="w-4 h-4 ml-1" />
                </button>
            );
        }
    };
    // const getReschedule = (item) => {
    //     return (
    //         <button
    //             onClick={() => {
    //                 movedInReschedule(item);
    //             }}
    //             className="text-amber-600 text-sm bg-amber-100 hover:bg-amber-200 px-2 py-1.5 rounded-md inline-flex items-center cursor-pointer transition-all duration-200 hover:text-amber-800"
    //         >
    //             Reschedule Booking
    //             <MdOutlineChevronRight className="w-4 h-4 ml-1" />
    //         </button>
    //     );
    // };
    const getPropertyName = (item) => {
        return (
            <div className="flex flex-col gap-1" onClick={() => goToDues('Tenant Info', item)}>
                <span className="text-gray-600 text-sm cursor-pointer">
                    {truncateText(item.propertyName, 25)}
                </span>
            </div>

        );
    };

    const moveInOutDate = (item) => {
        return (
            <div className="flex gap-3 ">
                <div className="flex flex-col text-sm text-gray-600">
                    <span>
                        {item.moveInDate
                            ? moment(item.moveInDate).format("DD, MMM YYYY")
                            : "-"}
                    </span>
                </div>
            </div>
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            // Display only "User" column for mobile screens
            return [
                {
                    Header: "Name",
                    accessor: "name",
                },
                {
                    Header: "Property",
                    accessor: "roomNum",
                },
            ];
        }
        return [
            {
                Header: "Name",
                accessor: "name",
            },
            {
                Header: "Property",
                accessor: "roomNum",
            },
            {
                Header: "Rent",
                accessor: "rent",
            },
            {
                Header: "Move In",
                accessor: "reschedule",
            },

            {
                Header: isMovingOut === 'M' ? "Moving Out" : "Date",
                accessor: "moveInOutDate",
            },
            // {
            //     Header: "Dues",
            //     accessor: "dues",
            // },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView, isMovingOut]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        sessionStorage.setItem(storageKey, pageIndex);
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                                style={{ maxWidth: "320px" }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Rent</strong>{" "}
                                                    {data[rowIndex].rent}
                                                </li>
                                                <li>
                                                    <strong>Agreement Duration</strong>{" "}
                                                    {data[rowIndex].moveInOutDate}
                                                </li>

                                                <li className="flex gap-2">
                                                    <strong>Status</strong>{" "}
                                                    {data[rowIndex].status}
                                                </li>
                                                <li>
                                                    <strong>Dues:</strong> {data[rowIndex].dues}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
            {/* {apiData?.length === 0 && <NotFoundModel />} */}
        </>
    );
};

const CustomTable = tw.table` w-full text-gray-600 `;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer w-full min-w-0`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
const MoveOutData = tw.p`text-gray-600 text-sm bg-amber-100 px-3 py-1 rounded-md inline-flex`
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const MenuOptions = tw.div`absolute bottom-8 right-0 py-2 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-1.5 text-base font-normal cursor-pointer hover:bg-gray-100`;
export default ReserveTenantTable;
